/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SecurityInterestDefinitionPrincipal {
    ISSUE_COST_PER_UNIT = 'ISSUE_COST_PER_UNIT',
    VALUE_PER_UNIT = 'VALUE_PER_UNIT',
    VALUE_FOR_TOTAL_ISSUE = 'VALUE_FOR_TOTAL_ISSUE',
}
